/** Patient chart notes — scoped by tab (Demographics vs Assessment). */
export const PATIENT_NOTE_TYPE_DEMOGRAPHICS = "General";
export const PATIENT_NOTE_TYPE_ASSESSMENT = "Assessment";

/** Unwrap list response from demographics or assessment notes APIs. */
export function extractPatientNotes(notesRes) {
  if (!notesRes) return [];
  const list =
    notesRes.result?.notes ||
    notesRes.notes ||
    notesRes.result?.items ||
    notesRes.data?.notes ||
    (Array.isArray(notesRes.result) ? notesRes.result : null) ||
    (Array.isArray(notesRes) ? notesRes : null);
  return Array.isArray(list) ? list : [];
}
